import styled from 'styled-components'

export const Wrapper = styled.div`
  background: ${props => props.theme.palette.general.light};

  > .wrapper {
    padding: 16px;
  }
`

export const Logo = styled.div`
  max-width: 155px;

  > a {
    display: block;

    svg {
      max-width: 100%;
    }
  }
`
